<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible && !rukuFormVisible && !logisticFormVisible && !returnBackVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">采购编号</span>
            <el-input
              v-model="listQuery.no"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">供应商</span>
            <el-input
              v-model="listQuery.supplier"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">材料编号</span>
            <el-input
              v-model="listQuery.materialNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">材料品牌</span>
            <el-input
              v-model="listQuery.materialBrand"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">材料名称</span>
            <el-input
              v-model="listQuery.materialName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">材料型号</span>
            <el-input
              v-model="listQuery.materialModel"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">开票状态</span>
            <el-select :filterable="true" v-model="listQuery.invoiceStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in invoiceStatusOptions"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">付款状态</span>
            <el-select :filterable="true" v-model="listQuery.paymentStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in paymentStatusOptions"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">入库状态</span>
            <el-select :filterable="true" v-model="listQuery.storageStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in storageStatusOptions"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">采购单状态</span>
            <el-select :filterable="true" v-model="listQuery.status" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in statusOptions"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">登记日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t('table.search') }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t('table.add') }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t('table.reset') }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{ isFilterCollapse ? '展开' : '收起' }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
          <span class="ml-10" style="display: flex">
            <span v-for="(item, index) in colorTooltips" :key="index" class="status-item">
              <span :style="{ backgroundColor: item.color }" class="status-square"></span>
              <span class="status-text">{{ item.tooltip }}</span>
            </span>
          </span>
        </div>
      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="rf => { if (rf) tableDataRef[0] = rf }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :tableRowClassName="tableRowClassName"
              :showSelection="true"
              :showSummary="true"
              :isShowPagination="false"
              :handleDefaultWidth="130"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              :canRefresh="false"
              :canChangeColumn="false"
              style="height:calc(100% );overflow:hidden;"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:operation-action="scope">
                <CommandRender
                  v-if="!(['换货单', '采购单'].includes(scope.row.type) && scope.row.type.fee === 0)"
                  :scopeRow='scope.row'
                  :codeList="btnList"
                  :permissionName="permissionName"
                  @command-change="handleCommand"
                />
                <el-link
                  v-if="['换货单', '采购单'].includes(scope.row.type) && scope.row.type.fee === 0 && scope.row.type.paid === 0"
                  class="mr-10"
                  href="javascript:void(0)"
                  type="danger"
                  @click="handleCommand('delete', scope.row)"
                >
                  删除
                </el-link>
              </template>
              <template v-slot:containsRate="scope">
                <span>{{ scope.row.containsRate ? '是' : '否' }}</span>
              </template>
              <template v-slot:deliverStatus="scope">
                <span>{{ ['换货单', '退货单'].includes(scope.row.type) ? '' : scope.row.deliverStatus }}</span>
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li
                    v-for="item in tabList"
                    :key="item.id"
                    :class="{ active: activeTab === item.id }"
                    @click="handleTabClick(item)">{{ item.name }}
                  </li>
                </ul>
              </div>
              <MaterialTable :materialData="detailList" v-if="activeTab === 1"/>
              <MaterialTable :materialData="rukuDetailList" mode="storage" v-if="activeTab === 2"/>
              <!-- <LogisticTable :sendFlag="0" TableName="TABLE_RECEIVE_INFO" permissionName="RECEIVE_INFO" v-if="activeTab===1" ref="LogisticTable" :sourceId="activeId" :sourceType="5" :isShowDatePicker="false"/>

              <TraceInfo v-if="activeTab===2" ref="TraceInfo" :id="activeId" :api="'purchase'"/> -->
        </div>
      </div>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :dialogFormVisible="dialogFormVisible"
      :api="'purchase'"
      :commandState="commandState"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <RukuFormComponent
      v-if="rukuFormVisible"
      :id="activeId"
      :api="'purchase'"
      :commandState="commandState"
      @update:visibel="() => rukuFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <LogisticFormComponent
      v-if="logisticFormVisible"
      api="logistics"
      :dialogFormVisible="logisticFormVisible"
      :purchasDetail="activeRow"
      :sendFlag="2"
      :selectcSourceId="activeRow.id * 1"
      @update:visibel="() => logisticFormVisible = false"
      @submit="handleSubmit()"
    >
      <template v-slot:baseInfo>
        <div class="form-title mb-10">
          <span class="label green">采</span>
          <span class="left">采购信息</span>
        </div>
        <el-descriptions title="" class="mb-10">
          <el-descriptions-item label="采购编号">{{ activeRow.no }}</el-descriptions-item>
          <el-descriptions-item label="供应商">{{ activeRow.supplier }}</el-descriptions-item>
          <el-descriptions-item label="供应商账户">{{ activeRow.account?.alias }}</el-descriptions-item>
          <el-descriptions-item label="总费用">{{ $currency(activeRow.fee) }}</el-descriptions-item>
          <el-descriptions-item label="税率">{{ activeRow.rate || 0 }}%</el-descriptions-item>
          <el-descriptions-item label="发票类型">{{ activeRow.invoiceType }}</el-descriptions-item>
        </el-descriptions>
      </template>
    </LogisticFormComponent>
    <el-dialog
      v-model="detailVisible"
      title="采购明细"
      width="70%"
    >
      <MaterialTable :materialData="detailList"/>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="detailVisible = false">
            关闭
          </el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="rukuDetailVisible"
      title="入库明细"
      width="70%"
    >
      <MaterialTable :materialData="rukuDetailList" mode="storage"/>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="rukuDetailVisible = false">
            关闭
          </el-button>
        </span>
      </template>
    </el-dialog>
    <div v-if="returnBackVisible">
      <div class="dataForm" style="margin-left:0">
        <div class="form-title mb-10 mt-10">
          <span class="label green">采</span>
          <span class="left">采购信息</span>
        </div>
        <el-descriptions>
          <el-descriptions-item label="供应商：">{{ activeRow.supplier }}</el-descriptions-item>
          <el-descriptions-item label="供应商账户：">{{ activeRow.account?.alias }}</el-descriptions-item>
          <el-descriptions-item label="是否含税：">{{ activeRow.containsRate ? '是' : '否' }}</el-descriptions-item>
          <el-descriptions-item label="税率：">{{ activeRow.rate }}%</el-descriptions-item>
          <el-descriptions-item label="发票类型：">{{ activeRow.invoiceType }}</el-descriptions-item>
          <el-descriptions-item label="付款周期：">{{ activeRow.payCycle }}</el-descriptions-item>
          <el-descriptions-item label="发货方式：">{{ activeRow.delivery }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <MaterialTable :materialData="detailList" ref="returnBackRef">
        <template v-slot:after>
          <el-table-column prop="" label="操作" fixed="right" min-width="100">
            <template #default="{ row }">
              <el-link type="primary" @click="handleAddComand(row)">添加</el-link>
            </template>
          </el-table-column>
        </template>
      </MaterialTable>
      <el-form
        ref="dataForm"
        :model="ruleForm"
        :rules="rules"
        label-position="top"
        label-width="100px"
        class="mb-20 mt-20"
      >
        <div>
          <div v-for="(item, index) in ruleForm.changeArray" :key="index" class="border-container">
            <el-form-item
              label="物料编号"
              :prop="'changeArray.' + index + '.materialNo'"
            >
              <el-input v-model="item.materialNo"/>
            </el-form-item>
            <el-form-item
              label="物料名称"
              :prop="'changeArray.' + index + '.materialName'"
            >
              <el-input v-model="item.materialName"/>
            </el-form-item>
            <template v-if="isReturn">
              <el-form-item
                label="退货数量"
                :prop="'changeArray.' + index + '.issueAmount'"
                :rules="[{ required: true, message: '请填写必填项', trigger: 'change' }]"
              >
                <el-input v-model="item.issueAmount" @input="handleInput($event, row)" type="number" :min="0"/>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item
                label="换货数量"
                :prop="'changeArray.' + index + '.issueAmount'"
                :rules="[{ required: true, message: '请填写必填项', trigger: 'change' }]"
              >
                <el-input v-model="item.issueAmount" type="number" :min="0"/>
              </el-form-item>
              <el-form-item
                label="换货单价"
                :prop="'changeArray.' + index + '.changeFee'"
                :rules="[{ required: true, message: '请填写必填项', trigger: 'change' }]"
              >
                <el-input-number
                  v-model="item.changeFee"
                  type="number"
                  :min="0"
                  :precision="2"
                  controls-position="right"/>
              </el-form-item>
            </template>
            <el-form-item
              label="是否出库"
              :prop="'changeArray.' + index + '.outbound'"
            >
              <el-checkbox v-model="item.outbound" label=""/>
            </el-form-item>
            <el-form-item
              v-if="ruleForm.changeArray[index]?.storages && ruleForm.changeArray[index].storages.length && item.outbound"
              label="出货库存位置"
              :prop="'changeArray.' + index + '.locationId'"
            >
              <el-select :filterable="true" v-model="item.locationId" class="filter-item" placeholder="输入关键字搜索" :clearable="true" @change="handleLocationChange($event, item, index)">
                <el-option
                  v-for="storage in ruleForm.changeArray[index].storages"
                  :key="storage.location.id"
                  :label="`${storage.location.name}/${storage.location.location}`"
                  :value="storage.location.id"
                />
              </el-select>
            </el-form-item>
            <template v-if="item.locationId">
              <el-form-item
                label="已入库数量"
                :rules="[{ required: true, message: '请填写必填项', trigger: 'change' }]"
              >
                <el-input v-model="item.selectLocation.amount" type="number" :min="0"/>
              </el-form-item>
              <el-form-item
                label="库存数量"
                :rules="[{ required: true, message: '请填写必填项', trigger: 'change' }]"
              >
                <el-input v-model="item.selectLocation.availableAmount" type="number" :min="0"/>
              </el-form-item>
            </template>
            <i @click="handleChangeDelete(item, index)" class="delete-icon"></i>
          </div>
          <el-form-item label="备注" prop="mark" class="fullWidth">
            <el-input v-model="ruleForm.mark" type="textarea" class="filter-item" clearable></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="dialog-footer mt-20 ">
        <el-button @click="returnBackVisible = false">
          {{ t('table.cancel') }}
        </el-button>
        <el-button
          type="primary"
          @click="handleReturnSubmit"
        >
          {{ t('table.confirm') }}
        </el-button>
      </div>
    </div>

    <el-button
type="primary"
circle
@click="handleSubMenuCollapse"
class="subMenuCollapseBtn"
               v-if="!dialogFormVisible && !rukuFormVisible && !logisticFormVisible && !returnBackVisible">
      {{ isSubMenuCollapse ? '展开' : '收起' }}
    </el-button>
  </div>
</template>
<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { defineComponent, reactive, toRefs, onMounted, ref, unref, nextTick, watch } from 'vue'
import { ElMessage, ElMessageBox, ElForm } from 'element-plus'
import { deleteById, putUrl, postUrl } from '@/apis/Dictionary'
import { getPurchasePage } from '@/apis/Purchase'
import { getPageList as getUrlList } from '@/apis/Form'

import { ArrayRowsItem } from '@/model/Index'

import FormComponent from './From.vue'
import RukuFormComponent from './RukuForm.vue'
import MaterialTable from './MaterialTable.vue'

import TableList from '@/components/common/TableList.vue'

// import TraceInfo from '@/components/traceInfo/Index.vue'
// import LogisticTable from '@/views/logistics/components/Table.vue'
import LogisticFormComponent from '@/views/logistics/components/Form.vue'
import CommandRender from '@/components/common/CommandRender.vue'
import { TableName, permissionName } from '@/utils/enum'

import { TableField } from './FieldTable'
import { defaultDate, pageVo, pageSizes } from '@/utils/index'

import { useI18n } from 'vue-i18n'
import mixin from '@/mixins'
import { invoiceStatusOptions, paymentStatusOptions, storageStatusOptions } from '@/constant/enumValues'

export default defineComponent({
  name: 'Purchase',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    // TraceInfo,
    // LogisticTable,
    RukuFormComponent,
    MaterialTable,
    CommandRender,
    LogisticFormComponent
  },
  setup() {
    const { t } = useI18n()
    const TraceInfo = ref(null)
    const tableDataRef = ref([])
    const returnBackRef = ref(null)
    const dataForm = ref(ElForm)

    const dataMap = reactive({
      TableName: TableName.TABLE_PURCHASE,
      permissionName: permissionName.PURCHASE,

      columnAllData: TableField.filter((kk: any) => kk.fieldKey !== 'times'),
      colorTooltips: [
        {
          color: 'red',
          tooltip: '审核不通过'
        },
        {
          color: 'blue',
          tooltip: '待完成'
        },
        {
          color: '#000000',
          tooltip: '完成'
        },
        {
          color: 'gray',
          tooltip: '已删除'
        }
      ],
      activeId: 0,
      activeRow: {},
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        no: undefined,
        invoiceNo: undefined,
        invoiceCode: undefined,
        supplier: undefined,
        startTime: '',
        endTime: '',
        status: undefined,
        invoiceStatus: undefined,
        paymentStatus: undefined,
        storageStatus: undefined,
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,
      rukuFormVisible: false,
      detailVisible: false,
      rukuDetailVisible: false,
      logisticFormVisible: false,
      returnBackVisible: false,
      detailList: [],
      btnList: [],
      rukuDetailList: [],
      statusOptions: [
        {
          id: 0,
          mark: '待审批'
        },
        {
          id: 10,
          mark: '审核不通过'
        },
        {
          id: 40,
          mark: '审核通过'
        },
        {
          id: 100,
          mark: '完成'
        }
      ],
      paymentStatusOptions,
      invoiceStatusOptions,
      storageStatusOptions,
      tabList: [
        {
          name: '明细',
          id: 1
        },
        {
          name: '入库明细',
          id: 2
        }
      ],
      activeTab: 1,

      salesManId: '',
      newHpx: 0,
      commandState: 'edit',
      statusOption: [],
      isReturn: true,
      ruleForm: {
        mark: '',
        changeArray: []
      },
      rules: {
        mark: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }]
      },
      async handleCommand(command: string, val?: any) {
        dataMap.commandState = command
        if (command !== 'column') {
          dataMap.activeId = val ? val.id : 0
          dataMap.activeRow = val
        }
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'copy':
          case 'edit':
            dataMap.handleUpdate()
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'ruku':
            dataMap.rukuFormVisible = true
            break
          case 'detail':
            getUrlList(`/purchase/${val.id}/actions/details`).then((result: any) => {
              dataMap.detailList = result
                ? result.map((item: any) => {
                  return {
                    ...item,
                    rate: val.rate
                  }
                })
                : []
              // dataMap.detailVisible = true
            })
            break
          case 'deliver':
            dataMap.handleDeliver(val)
            break
          case 'recall':
            dataMap.handleRecall(val)
            break
          case 'addLogistics':
            dataMap.activeRow = val
            dataMap.logisticFormVisible = true
            break
          case 'returnBack':
          case 'change':
            nextTick(() => {
              (dataForm.value as typeof ElForm).clearValidate()
            })
            await getUrlList(`purchase/${val.id}/actions/verify/returnOrExchange`)
            dataMap.ruleForm.mark = ''
            dataMap.ruleForm.changeArray = []
            dataMap.isReturn = command === 'returnBack'
            getUrlList(`/purchase/${val.id}/actions/details`).then((result: any) => {
              dataMap.detailList = result
                ? result.map((item: any) => {
                  return {
                    ...item,
                    issueAmount: 0,
                    changeFee: item.fee
                  }
                })
                : []
              dataMap.returnBackVisible = true
            })
            break
          case 'rukuDetail':
            getUrlList(`/purchase/${val.id}/actions/details?onlyIncoming=true`).then((result: any) => {
              dataMap.rukuDetailList = result
                ? result.map((item: any) => {
                  delete item.list
                  return {
                    ...item,
                    rate: val.rate
                  }
                })
                : []
              // dataMap.rukuDetailVisible = true
            })
            break
          case 'virtual':
            dataMap.handleVirtual(val)
            break
        }
      },
      handleRowClick(row: any) {
        if (!row) {
          return
        }
        dataMap.activeId = row.id
        dataMap.handleCommand('rukuDetail', row)
        dataMap.handleCommand('detail', row)
      },
      calcHeight() {
        return 'calc(100% - 50px)'
      },
      handleTabCommand(command: string) {
        if (this.activeTab === 1) {
          if (TraceInfo.value && TraceInfo.value) {
            ;(TraceInfo.value as any).handleCommand(command)
          }
        }
      },
      getList() {
        const {
          startTime,
          endTime
        } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }
        dataMap.listLoading = true
        getPurchasePage({
          ...dataMap.listQuery,
          pageType: 1
        }).then((res: any) => {
          dataMap.list = res.data
            ? res.data.map((k: any) => {
              k.supplierAccount = k.supplierAccount || {}
              return {
                ...k,
                supplierAccountName: k.supplierAccount.name,
                supplierAccountType: k.supplierAccount.type,
                supplierAccountBranchName: k.supplierAccount.branchName,
                supplierAccount: k.supplierAccount.account
              }
            })
            : []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
          dataMap.handleRowClick(dataMap.list[0])
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          no: undefined,
          invoiceNo: undefined,
          invoiceCode: undefined,
          supplier: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          status: undefined,
          invoiceStatus: undefined,
          paymentStatus: undefined,
          storageStatus: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        dataMap.dialogFormVisible = true
      },
      handleUpdate() {
        dataMap.dialogFormVisible = true
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('purchase', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleDeliver(row: any) {
        ElMessageBox.confirm(
          '确定要该物料已经发货吗？',
          '提示',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            putUrl(`purchase/${row.id}/actions/deliver`).then(() => {
              dataMap.getList()
              ElMessage({
                message: '操作成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleRecall(row: any) {
        ElMessageBox.confirm(
          '确定要撤回选中数据吗？',
          '提示',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            putUrl(`purchase/${row.id}/actions/apply/cancel`).then(() => {
              dataMap.getList()
              ElMessage({
                message: '操作成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleVirtual(row: any) {
        ElMessageBox.confirm(
          '确定要虚拟入库该数据吗？',
          '提示',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            putUrl(`storage/virtualStorage/${row.id}`).then(() => {
              dataMap.getList()
              ElMessage({
                message: '操作成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        getUrlList('dropdown/PurchaseStatus').then((res: any) => {
          dataMap.statusOption = res || []
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      tableRowClassName({ row }: any) {
        if (row.statusValue === '已删除') {
          return 'row-gray'
        }
        if (row.statusValue === '审核不通过') {
          return 'row-red'
        }
        if (row.statusValue === '待审批' || row.invoiceStatusValue === '待开票' || row.invoiceStatusValue === '部分开票' || row.paymentStatusValue === '待付款' || row.paymentStatusValue === '部分付款' || row.storageStatusValue === '待入库') {
          return 'row-blue'
        }
        return ''
      },
      handleReturnSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            // const _detailList = (returnBackRef.value as any).detail
            const _detailList = dataMap.ruleForm.changeArray
            const tempData = _detailList.map((kk: any) => {
              return {
                purchaseDetailId: kk.purchaseDetailId,
                materialId: kk.materialId,
                issueAmount: kk.issueAmount * 1,
                fee: kk.changeFee * 1,
                outbound: kk.outbound,
                locationId: kk.locationId
              }
            })
            const params = {
              details: tempData,
              type: !dataMap.isReturn ? 'EXCHANGE' : 'RETURN_GOODS',
              mark: dataMap.ruleForm.mark
            }
            postUrl(`purchase/${dataMap.activeId}/actions/returnOrExchange`, params).then(() => {
              ElMessage.success({
                message: '操作成功！',
                duration: 1000
              })
              dataMap.returnBackVisible = false
              dataMap.getList()
            })
          }
        })
      },
      handleInput(value: any, row: any) {
        console.log(88888, value, row)
      },
      handleAddComand(item: any) {
        dataMap.ruleForm.changeArray.push({
          ...item,
          issueAmount: item.amount || 0,
          changeFee: item.fee,
          locationId: '',
          outbound: false
        })
      },
      handleChangeDelete(item: any, index: number) {
        dataMap.ruleForm.changeArray.splice(index, 1)
      },
      handleLocationChange(locationId: any, item: any, index: number) {
        const selectLocation = dataMap.ruleForm.changeArray[index].storages.find((kk: any) => kk.location.id === locationId)
        item.selectLocation = selectLocation
      }
    })

    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./purchasManage/purchase',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })
    onMounted(async() => {
      mixinData.initHeight()
      dataMap.btnList = [
        {
          pkey: `${dataMap.permissionName}_EDIT`,
          name: '编辑',
          command: 'edit',
          visible: (row: any) => {
            return ['审核不通过', '已撤回'].includes(row.statusValue)
          }
        },
        // {
        //   pkey: `${dataMap.permissionName}_EDIT`,
        //   name: '入库',
        //   command: 'ruku',
        //   visible: (row: any) => {
        //     return ['待财务付款', '已付款', '部分入库'].includes(row.status) && row.storageStatus !== 1 && !['退货单'].includes(row.type)
        //   }
        // },
        // {
        //   pkey: `PURCHASE_VIRTUAL_RUKU`,
        //   name: '虚拟入库',
        //   command: 'virtual',
        //   visible: (row: any) => {
        //     return ['待财务付款', '已付款', '部分入库'].includes(row.status) && row.storageStatus !== 1 && !['退货单'].includes(row.type)
        //   }
        // },
        // {
        //   pkey: `${dataMap.permissionName}_DELETE`,
        //   name: '申请撤回',
        //   command: 'recall',
        //   visible: (row: any) => {
        //     return (['待财务付款'].includes(row.status) && (!row.invoiceStatus || ['未申请', '待开票', '无需开票'].includes(row.invoiceStatus))) && !['申请撤回'].includes(row.status) && !['退货单'].includes(row.type) && (['采购单', '换货单'].includes(row.type) && row.paid > 0)
        //   }
        // },
        // // {
        // //   pkey: `${dataMap.permissionName}_DELETE`,
        // //   name: '发货',
        // //   command: 'deliver',
        // //   visible: (row: any) => {
        // //     return ['待财务付款', '已付款'].includes(row.status) && ['待发货'].includes(row.deliverStatus)
        // //   }
        // // },
        // {
        //   pkey: `${dataMap.permissionName}_DELETE`,
        //   name: '添加快递信息',
        //   command: 'addLogistics',
        //   visible: (row: any) => {
        //     return ['待财务付款', '已付款'].includes(row.status) && row.deliveryFlag === 1
        //   }
        // },
        // // {
        // //   pkey: `${dataMap.permissionName}_LIST`,
        // //   name: '明细',
        // //   command: 'detail'
        // // },
        // // {
        // //   pkey: `${dataMap.permissionName}_LIST`,
        // //   name: '入库明细',
        // //   command: 'rukuDetail'
        // // },
        // {
        //   pkey: `${dataMap.permissionName}_LIST`,
        //   name: '退货',
        //   command: 'returnBack',
        //   visible: (row: any) => {
        //     return ['已发货'].includes(row.deliverStatus)
        //   }
        // },
        // {
        //   pkey: `${dataMap.permissionName}_LIST`,
        //   name: '换货',
        //   command: 'change',
        //   visible: (row: any) => {
        //     return ['已发货'].includes(row.deliverStatus)
        //   }
        // },
        {
          pkey: `${dataMap.permissionName}_DELETE`,
          name: '删除',
          command: 'delete',
          type: 'danger',
          visible: (row: any) => {
            return ['审核不通过', '已撤回'].includes(row.statusValue)
          }
        }
      ]
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownList()
    })
    return {
      t,
      ...toRefs(dataMap),
      ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse,
      tableDataRef,
      returnBackRef,
      dataForm
    }
  }
})
</script>
<style lang="scss">
.grid-layout-container {
  .vue-grid-item {
    background: #666;
  }
}

.status-item {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.status-square {
  width: 10px;
  height: 10px;
  margin-right: 5px;
}

.status-text {
  color: #000;
  font-size: 12px;
}
</style>
<style lang="scss" scope>
.statusStyle {
  .status {
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color: #fff;
  }
}

.redStatusStyle {
  .icon-tubiao-40 {
    color: #E74228;
  }

  .status {
    background-color: #E74228;
  }
}

.yellowStatusStyle {
  .icon-tubiao-40 {
    color: #F3D03C;
  }

  .status {
    background-color: #F3D03C;
  }
}

.warming-fp {
  border-radius: 4px;
  border: 1px solid $red;
  color: $red;
  padding: 8px;
  margin-bottom: 20px;
}
</style>
